(function () {
  'use strict';

  var MIN_LENGTH = 2;
  var DEBOUNCE_MS = 180;

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function init(root) {
    if (!root || root.dataset.predictiveSearchReady === 'true') return;
    root.dataset.predictiveSearchReady = 'true';

    var input = root.querySelector('[data-predictive-search-input]');
    var panel = root.querySelector('[data-predictive-search-panel]');
    var list = root.querySelector('[data-predictive-search-results]');
    var status = root.querySelector('[data-predictive-search-status]');
    var allResults = root.querySelector('[data-predictive-search-all]');
    if (!input || !panel || !list || !status || !allResults) return;

    var request = null;
    var activeIndex = -1;
    var options = [];

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
    }

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function setActive(index) {
      options.forEach(function (option) {
        option.classList.remove('is-active');
        option.setAttribute('aria-selected', 'false');
      });
      if (!options.length) {
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
        return;
      }
      activeIndex = (index + options.length) % options.length;
      var option = options[activeIndex];
      option.classList.add('is-active');
      option.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    }

    function render(products, query) {
      list.textContent = '';
      options = [];
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      allResults.href = '/search?type=product&q=' + encodeURIComponent(query);
      allResults.textContent = 'View all results for “' + query + '”';

      products.forEach(function (product, index) {
        var item = document.createElement('li');
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        item.id = root.id + '-option-' + index;

        var link = document.createElement('a');
        link.href = product.url;
        link.className = 'tx-predictive-search__result';

        if (product.featured_image && product.featured_image.url) {
          var image = document.createElement('img');
          image.src = product.featured_image.url;
          image.alt = '';
          image.loading = 'lazy';
          image.width = 56;
          image.height = 56;
          link.appendChild(image);
        }

        var label = document.createElement('span');
        label.textContent = product.title;
        link.appendChild(label);
        item.appendChild(link);
        list.appendChild(item);
        options.push(item);
      });

      status.textContent = products.length
        ? products.length + ' matching part' + (products.length === 1 ? '' : 's') + ' available.'
        : 'No matching parts found.';
      open();
    }

    function search() {
      var query = input.value.trim();
      if (query.length < MIN_LENGTH) {
        if (request) request.abort();
        status.textContent = '';
        list.textContent = '';
        close();
        return;
      }

      if (request) request.abort();
      request = new AbortController();
      status.textContent = 'Searching parts…';
      var endpoint = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show';

      fetch(endpoint, { signal: request.signal, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search failed');
          return response.json();
        })
        .then(function (data) {
          var products = (((data || {}).resources || {}).results || {}).products || [];
          render(products, query);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          status.textContent = 'Suggestions are temporarily unavailable. Press Enter to search.';
          list.textContent = '';
          open();
        });
    }

    input.addEventListener('input', debounce(search, DEBOUNCE_MS));
    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' && options.length) {
        event.preventDefault();
        setActive(activeIndex + 1);
      } else if (event.key === 'ArrowUp' && options.length) {
        event.preventDefault();
        setActive(activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        var link = options[activeIndex].querySelector('a');
        if (link) window.location.assign(link.href);
      } else if (event.key === 'Escape') {
        close();
      }
    });
    input.addEventListener('focus', function () {
      if (list.children.length && input.value.trim().length >= MIN_LENGTH) open();
    });
    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close();
    });
  }

  function start() {
    document.querySelectorAll('[data-predictive-search]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
